import { groupBy } from 'lodash';
import { RootState } from '../store';
import { createSelector } from '@reduxjs/toolkit';

export const selectMessages = (state: RootState) => state.messages.messages;

export const selectMessagesGroupedByBuyer = createSelector(
  [selectMessages],
  (messages) => {
    return groupBy(messages, 'senderId');
  }
);

// User-context-aware selector for messages by listingId and userId (works for all user types)
export const selectMessagesByListingIdAndUserId = (
  listingId: string,
  userId: string
) =>
  createSelector([selectMessages], (messages) =>
    messages.filter(
      (m) =>
        m.listingId === listingId &&
        (m.senderId === userId || m.receiverId === userId)
    )
  );
